import React, { useState } from "react";
import { PlanCard } from "../PlanCard";
import { listOfSubscriptions } from "../../../../../common/envConfig";

export const EnterprisePlans = ({ currentPlan }) => {
  return (
    <div className="flex flex-col md:flex-row gap-5 overflow-x-auto ">
      <PlanCard
        type="Studio"
        header="Coming soon!"
        subText="Perfect for indoor setups"
        textList={[
          "Advanced custom fields",
          "Audit log and data history",
          "Unlimited individual users",
          "Unlimited individual data",
          "Personalised + priotity service",
        ]}
        plan={["studio"]}
        currentPlan={currentPlan}
      />
      <PlanCard
        type="Enterprise"
        header="Contact sales"
        subText="Help your team level up with 3D"
        textList={[
          "Advanced custom fields",
          "Audit log and data history",
          "Unlimited individual users",
          "Unlimited individual data",
          "Personalised + priotity service",
        ]}
        plan={[
          listOfSubscriptions.ENTERPRISE_COACH,
          listOfSubscriptions.ENTERPRISE_MASTER,
        ]}
        currentPlan={currentPlan}
      />
    </div>
  );
};
